import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminEducationAddLoader = async (args: LoaderFunctionArgs) => {

    const getModulesResponse = await networkCall('/modules', { params: { companyId: args.params.id } });

    return { getModulesResponse, id: args.params.id };

};